import { axiosSEC } from "../http-common";

const transaction = (data: object, idEstacionamento: string) => {
    return axiosSEC.post('/Transacao/' + idEstacionamento, JSON.stringify(data));
};

const TransactionServiceSiTef = {
    transaction
}

export default TransactionServiceSiTef;